import axios from "axios";
//#region src/modules/core/data/axios.ts
var initAxios = (uri, keycloak, headers) => {
	const instance = axios.create({
		baseURL: uri,
		headers: { ...headers }
	});
	instance.interceptors.request.use(async (config) => {
		if (!keycloak.authenticated) return config;
		try {
			await keycloak.updateToken();
			config.headers.Authorization = `Bearer ${keycloak.token}`;
			return config;
		} catch (error) {
			console.error("Failed to refresh token or user is not authenticated", error);
			return Promise.reject(error);
		}
	});
	return instance;
};
//#endregion
export { initAxios };
